import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({ 
  history: createWebHashHistory(),
  routes: [
    {path: "/404",component: () => import("./pages/404.vue"),name: "404Page",meta: { title: "404" }, },
    //展示页面~~~~~~~~~~~~~~~~~~~~~~
    {path: "/",redirect: "/index" },
    {path: "/index",component: () => import("./pages/display/index.vue"),name: "indexPage",meta: { title: "主页" },redirect: "/home",
      children:[
        {path: "/home",component: () => import("./pages/display/home.vue"),name: "homePage",meta: { title: "首页" }},
        {path: "/profile",component: () => import("./pages/display/profile.vue"),name: "profilePage",meta: { title: "企业概况" }},
        {path: "/network",component: () => import("./pages/display/network.vue"),name: "networkPage",meta: { title: "网络安全" }},
        {path: "/education",component: () => import("./pages/display/education.vue"),name: "educationPage",meta: { title: "智慧教育" }},
        {path: "/video",component: () => import("./pages/display/video.vue"),name: "videoPage",meta: { title: "智能协作" }},
        {path: "/smartCity",component: () => import("./pages/display/smartCity.vue"),name: "smartCity",meta: { title: "智慧城市" }, },
        {path: "/articles",component: () => import("./pages/display/articles.vue"),name: "articlesPage",meta: { title: "新闻资讯" }, },
        {path: "/contact",component: () => import("./pages/display/contact.vue"),name: "contactPage",meta: { title: "联系我们" }, },
        
        //产品详情
        //{path: "/products/details",component: () => import("./pages/display/productsDetail.vue"),name: "productsDetail",meta: { title: "产品详情" }, },
        //文章详情
        {path: "/articles/details",component: () => import("./pages/display/articlesDetail.vue"),name: "articlesDetail",meta: { title: "文章详情" }, },    
        //视讯详情
        {path: "/video/videoDetail",component: () => import("./pages/display/videoDetail.vue"),name: "videoDetail",meta: { title: "视讯详情" }, },         
        //网络-----详情
        {path: "/network/networkDetail",component: () => import("./pages/display/networkDetail.vue"),name: "networkDetail",meta: { title: "网络详情" }, },       
        //教育-----详情
        {path: "/education/educationDetail",component: () => import("./pages/display/educationDetail.vue"),name: "educationDetail",meta: { title: "教育详情" }, },       
        //智慧城市-----详情
        {path: "/education/smartCityDetail",component: () => import("./pages/display/smartCityDetail.vue"),name: "smartCityDetail",meta: { title: "智慧城市详情" }, },  
      ]
    },

    //管理页面~~~~~~~~~~~~~~~~~~~~~~//公司简介0、网络安全1、智慧教育2、视讯3、新闻4、智慧城市5
     { path:'/login',component: () => import('./pages/manage/login.vue'), name: 'loginPage' , meta:{title:'登录'}},    
      { path:'/manage', component: () => import('./pages/manage/index.vue'), name: 'manageIndex' , meta:{title:'管理首页'},redirect: "/manage/homeEdit",
        children:[
          //首页编辑
          {path:'/manage/homeEdit',name:'homeEdit',component:() => import('./pages/manage/homeEdit.vue'),meta:{title:'首页编辑'},}, 
          //公司简介-编辑
          {path:'/manage/profileEdit',name:'profileEdit',component:() => import('./pages/manage/profileEdit.vue'),meta:{title:'公司简介'},}, 
          //新闻资讯
          {path:'/manage/articleList',name:'articleList',component:() => import('./pages/manage/articleList.vue'),meta:{title:'文章列表'},}, 
          //用户管理
          {path:'/manage/users',name:'userList',component:() => import('./pages/manage/userList.vue'),meta:{title:'用户管理'}, },   
          //网站信息
          {path:'/manage/infoSetting',name:'infoSetting',component:() => import('./pages/manage/infoSetting.vue'),meta:{title:'网站信息'},},  
          //网络安全-文章
          {path:'/manage/networkList',name:'networkList',component:() => import('./pages/manage/networkList.vue'),meta:{title:'网络安全列表'},}, 
          //智能协作-文章
          {path:'/manage/videoList',name:'videoList',component:() => import('./pages/manage/videoList.vue'),meta:{title:'智能协作列表'},}, 
          //智慧教育-文章
          {path:'/manage/educationList',name:'educationList',component:() => import('./pages/manage/educationList.vue'),meta:{title:'智慧教育列表'},}, 
          //智慧城市-文章
          {path:'/manage/smartCityList',name:'smartCityList',component:() => import('./pages/manage/smartCityList.vue'),meta:{title:'智慧城市列表'}},
          //企业资质-编辑
          {path:'/manage/certificatesList',name:'certificatesList',meta:{title:'企业资质'},
            children:[
              //三体系
              {path:'/manage/certificatesList/certificatesList1',name:'certificatesList1',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:10, title:'三体系'}}, 
              //商标
              {path:'/manage/certificatesList/certificatesList2',name:'certificatesList2',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:11,title:'商标'},}, 
              //高企
              {path:'/manage/certificatesList/certificatesList3',name:'certificatesList3',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:12,title:'软件企业'},}, 
            ]
          }, 
          //产品资质-编辑
          {path:'/manage/productCer',name:'productCer',meta:{title:'产品资质'},
            children:[
              //专利
              {path:'/manage/productCer/productCer1',name:'productCer1',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:13,title:'专利'}}, 
              //PCT
              {path:'/manage/productCer/productCer2',name:'productCer2',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:14,title:'PCT'},}, 
              //著作权
              {path:'/manage/productCer/productCer3',name:'productCer3',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:15,title:'著作权'},}, 
              //软件产品登记
              {path:'/manage/productCer/productCer4',name:'productCer4',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:16,title:'软件产品登记'},}, 
            ]
          }, 
          //高校合作
          {path:'/manage/cooperate',name:'cooperate',component:() => import('./pages/manage/certificatesList.vue'),meta:{type:17,title:'高校合作'},}, 

        ]
      },


  ],
});

// 在路由前，校验token是否存在
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem('userRole')
  if ( to.path === "/manage" || to.path === "/manage/articleList" || to.path === "/manage/infoSetting" || to.path === "/manage/networkList" || to.path === "/manage/videoList" || to.path === "/manage/educationList"  || to.path === "/manage/profileEdit"  || to.path === "/manage/certificatesList"   || to.path === "/manage/certificatesList2" ) { 
    if (token) {
      next();
    } else {
      next('/login')
    }
  }else if( to.path === "/manage/users" ){
    if(token && role ==0){
      next();
    }else if(token && role ==1){
      next('/404');
    }else{
      next('/login')
    }
  } else {
    next();
  }
});



// router.beforeEach((to, from, next) => {
//   const token = sessionStorage.getItem("token");
//   console.log('token是什么',token)
//   if ( to.path === "/manage" || to.path === "/manage/productList" || to.path === "/manage/articleList" || to.path === "/manage/users" || to.path === "/manage/infoSetting"  ) {
//     if (token) {
//       next();
//     } else {
//       next('/login')
//     }
//   } else {
//     next();
//   }
// });



export default router;
